const TaskStatus = Object.freeze({
  TO_DO: 0,
  RUNNING: 1,
  DONE: 2,
  AWAITING: 9,
})

export default TaskStatus
